<script setup lang="ts">
import { fr } from '@nuxt/ui/locale'
</script>

<template>
  <NuxtLoadingIndicator color="var(--ui-primary)" :height="2" />
  <UApp :locale="fr" :tooltip="{ delayDuration: 0}">
    <NuxtLayout>
      <NuxtPage />
    </NuxtLayout>
  </UApp>
</template>